import { render, staticRenderFns } from "./MeSettings.vue?vue&type=template&id=5081d81e&"
import script from "./MeSettings.vue?vue&type=script&lang=js&"
export * from "./MeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports